import { Badge, DotLoading, Ellipsis, InfiniteScroll, List } from "antd-mobile";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { useGetMessageList, useUpdateMessageStatus } from "../../hooks/systemAnnoucement.hook";
import DetailPopup from "../DetailPopup";
import ListItem from "../ListItem";

function Message() {
  const { t } = useTranslation();
  const [showDetail, setShowDetail] = useState(false);
  const [nowDetailItem, setNowDetailItem] = useState({});
  const getMessageList = useGetMessageList({
    getNextPageParam: (lastPage, pages) => {
      if (pages.length < lastPage.last_page) {
        return pages.length + 1;
      } else {
        return undefined;
      }
    },
  });
  const { mutate: updateMessageStatus } = useUpdateMessageStatus();
  const InfiniteScrollContent = ({ hasMore }) => {
    return (
      <>
        {hasMore ? (
          <>
            <DotLoading />
          </>
        ) : (
          <span>{t("mobile.infiniteScroll.bottom")}</span>
        )}
      </>
    );
  };
  return (
    <div style={{ height: "calc(100vh - 87px)", overflowY: "scroll" }}>
      <List>
        {getMessageList.data?.pages?.map((page, index) => {
          return page.data.map((item, index) => {
            return (
              <ListItem
                key={item.id}
                title={item.title}
                date={item.created_at}
                onClick={() => {
                  if (item.read_status == 0) updateMessageStatus(item.id);
                  setNowDetailItem(item);
                  setShowDetail(true);
                  console.log("id", item.id);
                }}
                contentRender={() => {
                  //remove all line breaks
                  const content = item.content.replace(/(\r\n|\n|\r)/gm, "");
                  return (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Ellipsis
                        direction="end"
                        rows={2}
                        content={content}
                        style={{ paddingRight: "8px" }}
                      />
                      <Badge content={item.read_status == 0 ? Badge.dot : ""} />
                    </div>
                  );
                }}
              />
            );
          });
        })}
      </List>
      <InfiniteScroll loadMore={getMessageList.fetchNextPage} hasMore={getMessageList.hasNextPage}>
        <InfiniteScrollContent hasMore={getMessageList.hasNextPage} />
      </InfiniteScroll>
      <DetailPopup
        visible={showDetail}
        onClose={() => {
          setShowDetail(false);
          setNowDetailItem({});
        }}
        detailItem={nowDetailItem}
      />
    </div>
  );
}

export default Message;
